/**
 * Data API Service
 * Handles all API calls related to market data, charts, and prices
 */

import api from '../api';

/**
 * Get historical chart data formatted for TradingView Lightweight Charts
 * @param {string} symbol - Stock symbol (e.g., 'RELIANCE', 'TCS', 'M&M')
 * @param {string} period - Time period: '1y', '2y' (default), '5y'
 * @returns {Promise} Chart data with OHLC values and UNIX timestamps
 */
export const getHistoricalChartData = async (symbol, period = '2y') => {
  try {
    console.log('--- DEBUG: getHistoricalChartData called ---');
    console.log('Symbol:', symbol);
    console.log('Period:', period);
    console.log('URL path: /api/v1/data/historical-chart/' + symbol);
    
    const response = await api.get(`/api/v1/data/historical-chart/${symbol}`, {
      params: { period }
    });
    
    console.log('getHistoricalChartData response:', response.data);
    return response.data;
  } catch (error) {
    console.error('--- DEBUG: Error fetching historical chart data ---');
    console.error('Full error:', error);
    console.error('Error response:', error.response);
    console.error('Error status:', error.response?.status);
    console.error('Error data:', error.response?.data);
    throw error;
  }
};

/**
 * Get latest OHLC quote data for a stock symbol
 * @param {string} symbol - Stock symbol (e.g., 'ITC', 'BEL', 'RELIANCE')
 * @returns {Promise} Latest OHLC quote data
 */
export const getQuoteData = async (symbol) => {
  try {
    console.log('--- DEBUG: getQuoteData called ---');
    console.log('Symbol:', symbol);
    
    const response = await api.get(`/api/v1/data/quote/${symbol}`);
    console.log('getQuoteData response:', response.data);
    return response.data;
  } catch (error) {
    console.error('--- DEBUG: Error fetching quote data ---');
    console.error('Full error:', error);
    console.error('Error response:', error.response);
    throw error;
  }
};

/**
 * Get latest price for a stock symbol
 * @param {string} symbol - Stock symbol (e.g., 'RELIANCE', 'TCS')
 * @returns {Promise} Latest price data
 */
export const getLatestPrice = async (symbol) => {
  try {
    console.log('--- DEBUG: getLatestPrice called ---');
    console.log('Symbol:', symbol);
    console.log('URL path: /api/v1/data/latest-price/' + symbol);
    
    const response = await api.get(`/api/v1/data/latest-price/${symbol}`);
    console.log('getLatestPrice response:', response.data);
    return response.data;
  } catch (error) {
    console.error('--- DEBUG: Error fetching latest price ---');
    console.error('Full error:', error);
    console.error('Error response:', error.response);
    console.error('Error status:', error.response?.status);
    console.error('Error data:', error.response?.data);
    throw error;
  }
};

